import { MDBBtn, MDBCard, MDBAlert, MDBCardBody,  MDBCardText, MDBCardTitle, MDBCol, MDBFooter, MDBInput,  MDBRow, MDBTable, MDBModal, MDBIcon, MDBModalBody, MDBModalFooter, MDBModalHeader } from 'mdbreact'
import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
// import discount_icon from '../../Assets/discount.svg';
import styles from './PaymentDetails.module.css'
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import BasicInfoCard from '../BasicInfoCard/BasicInfoCard';
import axios from '../../authAxios';
import crypto from 'crypto';
import { loadStripe } from "@stripe/stripe-js";
import InputLabel from '@material-ui/core/InputLabel';
import paymentLoader from "../../Assets/spinner.gif"
// import TextField from '@material-ui/core/TextField';
import PaymentGateway from './PaymentGateway/PaymentGateway';
import OtpInput from "react-otp-input";



const brand_color = localStorage.getItem('brand_color')
const stripePromise = loadStripe("pk_test_51HA9IIBGx20p6bomzExGPaJKDpLPPuNvmonfGKr41T50chxOp1fmpzDpkTwkjhUaVfBSuKfFqcPgiKqnjv5jst8d00akv1uJuf");

export class PaymentDetails extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            brand_color : "",
            modal: false,
            isCouponApplied: false,
            dataObj: {},
            additionalTax: [],
            additional_tax_type: '',
            additional_tax_percentage: '',
            additional_tax_value: '',
            supported_currency: [],
            selected_currency: '',
            server_url: '',
            show_loader: false,
            showMissingFieldModal: false,
            coupon_code: "",
            applyCouponCode: false,
            creditCard: "",
            banner_image: "",
            banner_message: "",
            value_unit: "",
            value: "",
            maxvalue: "",
            promocode_title: "",
            promocode_subtitle: "",
            applyFinalCouponCode: false,
            promocode_challenge: "",
            email_id: "",
            center: "",
            errormsg: "",
            alertMsg: false,
            success: false,
            discount_value: "",
            number1: "",
            promocodeChallengeCheck: [],
            showDeleteModall: false,
            countryList: [],
            countryName: "",
            cityList: [],
            cityName: "",
            paymentMode: "",
            paymentMethod: [],
            proceed: false,
            proceedArray: [],
            isOfflineError: false,
            errorTextMsg: '',
            isOnlineError: false,
            showPaymentMethod : false


        }
        //this.handlePayNow = this.handlePayNow.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.missingFieldToggle = this.missingFieldToggle.bind(this)
        this.handleCouponCode = this.handleCouponCode.bind(this)
        this.applyCode = this.applyCode.bind(this)

        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.api_getPaymentDetails = this.api_getPaymentDetails.bind(this)
        this.removeCoupon = this.removeCoupon.bind(this)
        this.handleCreditCard1 = this.handleCreditCard1.bind(this)
        this.deleteToggle = this.deleteToggle.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this)
        this.handleCityChange = this.handleCityChange.bind(this)
        this.handlePaymentMethod = this.handlePaymentMethod.bind(this)
        this.handlePaymentProceed = this.handlePaymentProceed.bind(this)
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });


    }

    componentDidMount() {
        this.setState({ brand_color: localStorage.getItem('brand_color') })
        var host = localStorage.getItem('host')

        if (host === 'visaero') {
            this.setState({ server_url: "https://visaero-stage-backend.visaero.com" })
        } else if (host === "visadone") {
            this.setState({ server_url: "https://visaero-stage-backend.visaero.com" })
        } else if (host === "192.168.1.16") {
            this.setState({ server_url: "http://192.168.1.16:3000" })
        } else if (host === "localhost") {
            this.setState({ server_url: "http://192.168.1.16:3000" })
        }
        // this.setState({ server_url: "http://192.168.1.16:3000" })

        this.api_getCountryCities()


        this.setState({ selected_currency: localStorage.getItem('base_currency_symbol') })
        // axios
        //     .get('/brule-engine/getSupportedCurrencies?host='+localStorage.getItem("host"))
        //     .then(res => {
        //          console.log(">>>>>>>>>>currency" ,  res.data.dataobj.data);
        //         this.setState({supported_currency:res.data.dataobj.data})
        //     })
        setTimeout(() => {
            axios
                .get('/visa/getVisaPaymentSummary', {
                    params: {
                        applicationId: localStorage.getItem('application_id'), //"5fe06f0ffc733da4b1a41d05"
                        orderCurrency: localStorage.getItem('base_currency_symbol')
                    }
                })
                .then((resp) => {
                    // console.log("Taxes=>>>>", resp)
                    // console.log(resp.data.dataobj)
                    localStorage.setItem("application_reference_code", resp.data.dataobj.application_reference_code)

                    this.setState({ dataObj: resp.data.dataobj })
                    this.setState({ additionalTax: resp.data.dataobj.additional_tax })
                    this.setState({
                        additional_tax_type: this.state.additionalTax[0].additional_tax_type,
                        additional_tax_percentage: this.state.additionalTax[0].additional_tax_percentage,
                        additional_tax_value: this.state.additionalTax[0].additional_tax_value
                    })
                    this.setState({ success: (Object.entries(resp.data.dataobj.payment_promo_code_obj).length > 1 ? true : false) })
                    this.setState({ discount_value: resp.data.dataobj.promocode_discount })
                    this.setState({ promocode_title: resp.data.dataobj.payment_promo_code_obj.promocode })
                    this.setState({
                        banner_image: resp.data.dataobj.payment_promo_code_obj.banner_icon, promocode_subtitle: resp.data.dataobj.payment_promo_code_obj.promocode_subtitle,
                        banner_message: resp.data.dataobj.payment_promo_code_obj.message
                    })
                    this.setState({ supported_currency: resp.data.dataobj.supported_currencies })
                    localStorage.setItem("visa_id", resp.data.dataobj.visa_id)
                })
                .catch(err => {
                    console.log(err);
                })
        }, 200)
    }
    api_getCountryCities() {
        var firstCountry = localStorage.getItem('origin_country')
        this.setState({countryName: firstCountry })
        axios.get("/visa-admin/getCountriesCities", {
            params: {
                "host": localStorage.getItem("host")
            }
        }).then((res) => {
            // console.log(res);
            if (res.data.data === "success") {

                this.setState({
                    countryList: res.data.dataobj[0].countries_cities,
                    countryName: firstCountry
                });

                // console.log("Country", country);
                var country = res.data.dataobj[0].countries_cities;
                var citiesList = [];
                country.map((city) => {
                    if (city.country_name == firstCountry) {
                        citiesList = city.cities;
                    }
                });
                if (citiesList.length === 0) {
                    return
                }

                var firstCity = citiesList[0].city_name
                console.log("firstCity", firstCity);

                var citiesNameArray = [];
                citiesList.map((city) => {
                    citiesNameArray.push(city.city_name);
                });


                var cities = []
                citiesList.map((city) => {
                    if (city.city_name == firstCity) {
                        cities.push(city.supported_payments)
                    }

                })
                this.setState({ paymentMethod: cities[0] })


                var city = cities[0]
                var pay_mode = ""
                city.map((ci, index) => {
                    if (index === 0) {
                        pay_mode = ci.payment_mode
                    }
                })

                this.setState({ paymentMode: pay_mode, showPaymentMethod: true })
                this.setState({
                    cityList: citiesNameArray,
                    cityName: firstCity
                });
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    deleteToggle = () => {
        this.setState({ showDeleteModall: !this.state.showDeleteModall })
    }

    handleModalDeleteClick = () => {
        this.setState({ showDeleteModall: !this.state.showDeleteModall })
        var card = this.state.cardToDelete
        let filteredArray = this.state.uploadedDoc.filter(item => item.file_name !== card.file_name)
        this.setState({ uploadedDoc: filteredArray });
    }

    handleOptionChange(event) {
        // console.log(event.target.value)
        this.setState({ selected_currency: event.target.value })
        localStorage.setItem('base_currency_symbol', event.target.value)
        this.api_getPaymentDetails()
    }

    api_getPaymentDetails() {
        axios
            .get('/visa/getVisaPaymentSummary', {
                params: {
                    applicationId: localStorage.getItem('application_id'), //"5fe06f0ffc733da4b1a41d05"
                    orderCurrency: localStorage.getItem('base_currency_symbol')
                }
            })
            .then((resp) => {
                console.log("payment summary")
                // {this.state.success === "success" &&  
                //     console.log("after coupon applied ==>" ,  resp.data.dataobj)

                // }   
                // console.log(resp.data.dataobj)
                localStorage.setItem("application_reference_code", resp.data.dataobj.application_reference_code)

                this.setState({ dataObj: resp.data.dataobj })
                this.setState({ discount_value: resp.data.dataobj.promocode_discount })
                this.setState({ additionalTax: resp.data.dataobj.additional_tax })
                this.setState({
                    additional_tax_type: this.state.additionalTax[0].additional_tax_type,
                    additional_tax_percentage: this.state.additionalTax[0].additional_tax_percentage,
                    additional_tax_value: this.state.additionalTax[0].additional_tax_value
                })
                this.setState({ success: (Object.entries(resp.data.dataobj.payment_promo_code_obj).length > 1 ? true : false) })
                this.setState({ discount_value: resp.data.dataobj.promocode_discount })
                this.setState({ promocode_title: resp.data.dataobj.payment_promo_code_obj.promocode })
                this.setState({
                    banner_image: resp.data.dataobj.payment_promo_code_obj.banner_icon, promocode_subtitle: resp.data.dataobj.payment_promo_code_obj.promocode_subtitle,
                    banner_message: resp.data.dataobj.payment_promo_code_obj.message
                })
                this.setState({ supported_currency: resp.data.dataobj.supported_currencies })

                // alert(this.state.promocode_title)
            })
            .catch(err => {
                console.log(err);
            })
    }
    //handlePayNow(){


    missingFieldToggle = () => {
        this.setState({ showMissingFieldModal: !this.state.showMissingFieldModal })
        this.setState({ applyCouponCode: false })
        this.setState({ promocode_challenge: "", email_id: "" })

        this.setState({ coupon_code: "" })
        this.setState({ alertMsg: false })
        // this.clearOTP()
        this.setState({ number1: "" })


    }

    handlePaymentProceed() {
        if (this.state.countryName === '') {
            this.setState({
                isOfflineError: true,
                errorTextMsg: 'Please select country'
            })
            return
        }
        if (this.state.cityName === '') {
            this.setState({
                isOfflineError: true,
                errorTextMsg: 'Please select city'
            })
            return
        }

        this.api_updatePaymentOffline()
    }

    api_updatePaymentOffline() {
        // console.log("payment config array ---------------")
        var configArray = []
        this.state.paymentMethod.map((payment) => {
            if (payment.payment_mode === this.state.paymentMode) {
                configArray.push(payment)
            }

        })
        if (configArray.length === 0) {
            this.setState({
                isOfflineError: true,
                errorTextMsg: 'payment configuration is not available please select other payment mode'
            })
            return
        }
        axios.post('/visa-payment/updatePaymentOfflineDetails', {
            "application_id": localStorage.getItem("application_id"),
            "country": this.state.countryName,
            "city": this.state.cityName,
            "payment_mode": this.state.paymentMode,
            "payment_config": configArray
        }).then((res) => {
            // console.log(res);
            if (res.data.data === "success") {
                // alert("success")
                // this.setState({ proceed: true })
                this.handleProceedPage()
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    handleProceedPage() {
        axios.get("/visa-admin/getCountriesCities", {
            params: {
                "host": localStorage.getItem("host")
            }
        }).then((res) => {
            // console.log("response", res);
            var country = res.data.dataobj[0].countries_cities
            // console.log("Country", (country));

            var citiesList = []
            country.map((city) => {
                if (city.country_name == this.state.countryName) {
                    citiesList = city.cities
                }
            })
            // console.log("CITIES DATA", citiesList);

            var cities = []
            citiesList.map((city) => {
                if (city.city_name == this.state.cityName) {
                    cities.push(city.supported_payments)
                }

            })
            // console.log(">>>>>", cities[0]);
            // this.setState({ paymentMethod: cities[0] })


            var city = cities[0]
            var payArray = []
            city.map((pay) => {
                if (pay.payment_mode == this.state.paymentMode) {
                    payArray.push(pay.payment_config)
                }
            })

            // console.log("PROCEED CITIES", city);
            // console.log("MODEEE", payArray[0]);

            this.setState({ proceedArray: payArray[0] })
            
        }).catch((err) => {
            console.log(err);
        })

        this.setState({ proceed: true })

    }

    handleCountryChange(e) {

        this.setState({
            countryName: e.target.value,
            cityList: [],
            cityName: '',
            paymentMode: '',
            paymentMethod: [],
            isOfflineError: false,
            isOnlineError: false
        })

        axios.get("/visa-admin/getCountriesCities", {
            params: {
                host: localStorage.getItem("host")
            }
        }).then((res) => {
            // console.log("resp===>", res);
            if (res.data.data == "error") {

            } else {
                //    this.setState({ countryList : res.data.dataobj[0].countries_cities })
                var country = res.data.dataobj[0].countries_cities
                var citiesList = []
                country.map((city) => {
                    if (city.country_name == e.target.value) {
                        citiesList = city.cities
                    }
                })
                // console.log("Country", (citiesList));
                var firstCity = citiesList[0].city_name
                console.log("firstCity", firstCity);

                var citiesNameArray = [];
                citiesList.map((city) => {
                    citiesNameArray.push(city.city_name);
                });


                var cities = []
                citiesList.map((city) => {
                    if (city.city_name == firstCity) {
                        cities.push(city.supported_payments)
                    }

                })
                this.setState({ paymentMethod: cities[0] })


                var city = cities[0]
                var pay_mode = ""
                city.map((ci, index) => {
                    if (index === 0) {
                        pay_mode = ci.payment_mode
                    }
                })

                this.setState({ paymentMode: pay_mode, showPaymentMethod: true })
                this.setState({
                    cityList: citiesNameArray,
                    cityName: firstCity
                })
            }
        }).catch((err) => {
            console.log(err);
        })
    }


    handleCityChange(e) {
        this.setState({
            cityName: e.target.value,
            isOfflineError: false,
            showPaymentMethod: false,
            isOnlineError: false
        })

        axios.get("/visa-admin/getCountriesCities", {
            params: {
                host: localStorage.getItem("host")
            }
        }).then((res) => {
            // console.log("response", res);
            var country = res.data.dataobj[0].countries_cities
            // console.log("Country", (country));

            var citiesList = []
            country.map((city) => {
                if (city.country_name == this.state.countryName) {
                    citiesList = city.cities
                }
            })
            // console.log("CITIES DATA", citiesList);

            var cities = []
            citiesList.map((city) => {
                if (city.city_name == e.target.value) {
                    cities.push(city.supported_payments)
                }

            })
            // console.log(">>>>>", cities[0]);
            this.setState({ paymentMethod: cities[0] })


            var city = cities[0]
            var pay_mode = ""
            city.map((ci, index) => {
                if (index === 0) {
                    pay_mode = ci.payment_mode
                }
            })

            this.setState({ paymentMode: pay_mode, showPaymentMethod: true })

        }).catch((err) => {
            console.log(err);
        })

    }


    // handlePaymentCard = (card) =>{
    //     console.log(card);

    //     var info = "Account Name: SATGURU TRAVEL AND TOURISM BELGIUM - IBAN: BE35 3631 7422 1437 - BIC: BBRUBEBB - Address: Chauseé de Wavre 25, 1050 Ixelles, Belgium - Contact: +32 2545 0110 - Email: Mukesh.sahu@satgurutravel.com"

    //     var cardInfo = info.split("-")

    //     console.log(cardInfo);

    //     return(
    //         <>
    //         <MDBCol lg="4">

    //                  <MDBCard>
    //                     <MDBCardBody>
    //                             {cardInfo.forEach((info1,i)=>{
    //                                 console.log(info1.replace(" ",""));

    //                         <MDBRow>
    //                             <MDBCol>
    //                             <p style={{color : "black" , zIndex : "99999"}}>abc</p>
    //                             </MDBCol>
    //                         </MDBRow>
    //                             })}
    //                     </MDBCardBody>
    //                 </MDBCard>
    //             </MDBCol>
    //             </>
    //     )

    // }

    handlePaymentMethod(e) {
        this.setState({ paymentMode: e.target.value })
    }

    applyCode() {

        // let a = this.state.dataObj.service_fees
        // // console.log("A", a);
        // let b = this.state.value
        // // console.log("B", b); 
        // let c = a * (b /100)
        // // let c = 700
        // // console.log("C" , c);
        // let d =  (c > this.state.maxvalue) ?  this.state.maxvalue : c

        // this.setState({maxvalue : d})
        let promocodeChallengeValue = ""
        if (this.state.promocode_challenge === "bin") {

            promocodeChallengeValue = this.state.number1
            // console.log("Credit Card Number ===>", promocodeChallengeValue);
        }

        if (this.state.promocode_challenge === "domain") {
            promocodeChallengeValue = this.state.email_id
        }


        // let creditCardCheck = this.state.promocodeChallengeCheck.filter(card => card === creditCard)
        // alert(creditCardCheck)
        let res = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (!res.test(this.state.email_id) && this.state.promocode_challenge === "domain") {
            this.setState({ errormsg: "Enter email address in correct format", alertMsg: true })
            this.setState({ showMissingFieldModal: true })
            // this.setState({applyCouponCode : false})

        } else {



            axios.post("/visa/apply_promocode", {
                "promo_code": this.state.coupon_code,
                "promo_code_challenge_value": promocodeChallengeValue,
                "application_id": localStorage.getItem("application_id"),
                "user_id": localStorage.getItem("user_id")
            }).then((res) => {
                // console.log("Applied Coupon====>", res);
                if (res.data.data === "success") {
                    this.api_getPaymentDetails()

                    this.setState({ success: res.data.data })
                    this.setState({ showMissingFieldModal: false })
                } else {
                    // console.log(res);
                    this.setState({ errormsg: (res.data.dataobj.promocode_challenge_result).toUpperCase() + "ED." })
                    this.setState({ alertMsg: true })
                    this.setState({ showMissingFieldModal: true })
                    this.setState({ applyCouponCode: false })

                    // alert("Something went wrong.")
                    // this.setState({})
                    this.setState({ promocode_challenge: "" })
                    this.clearOTP()
                }
            }).catch((err) => {
                console.log(err);
            })
        }

        this.setState({ applyFinalCouponCode: true })
    }









    handleCouponCode() {

        axios.post("/visa/verify_promocode", {
            "promo_code": this.state.coupon_code,
            "user_id": localStorage.getItem("user_id"),
            "visa_id": localStorage.getItem("visa_id"),
            "currency": localStorage.getItem("base_currency_symbol"),
            "host": localStorage.getItem("host")
        }).then((res) => {
            // console.log("CouponCode===>", res);
            if (res.data.data === "success") {
                this.setState({ applyCouponCode: true })
                this.setState({
                    banner_image: (res.data.dataobj.banner_icon).replace("%22", ""), value_unit: res.data.dataobj.value_unit, value: res.data.dataobj.value,
                    maxvalue: res.data.dataobj.max_value, promocode_subtitle: res.data.dataobj.promocode_subtitle, banner_message: res.data.dataobj.message,
                    promocode_challenge: res.data.dataobj.promocode_challenge, promocodeChallengeCheck: res.data.dataobj.promocode_challenge_check
                })
                this.setState({ alertMsg: false })
                // console.log("image >>>>>>" , this.state.banner_image);
            } else {
                // alert(res.data.msg)
                this.setState({ errormsg: res.data.msg })
                this.setState({ applyCouponCode: false })
                this.setState({ alertMsg: true })


            }
        }).catch((err) => {
            console.log(err);
            // alert(err.msg)
        })


    }


    removeCoupon() {

        axios.post('/visa/remove_promocode', {
            "application_id": localStorage.getItem("application_id")
        }).then((res) => {
            // console.log(res);
            if (res.data.data === "success") {
                // alert(res.data.msg)
                this.api_getPaymentDetails()
                this.setState({ showDeleteModall: !this.state.showDeleteModall })

            }
        })
    }

    handleEmailChange(e) {
        this.setState({ email_id: e.target.value })

    }


    handleCreditCard1 = e => {

        this.setState({ number1: e })

    };



    clearOTP() {
        this.setState({
            number1: '',

        })
        this.textInput1.focus();
    }


    render() {

        if (this.state.proceed) {

            return <PaymentGateway mode={this.state.paymentMode} payArray={this.state.proceedArray} />
        }


        const handlePayNow = async (event) => {
            if (this.state.countryName === '') {
                this.setState({
                    isOnlineError: true,
                    errorTextMsg: 'Please select country'
                })
                return
            }
            if (this.state.cityName === '') {
                this.setState({
                    isOnlineError: true,
                    errorTextMsg: 'Please select city'
                })
                return
            }

            // console.log("Handling payment for " + this.state.dataObj.currency)
            this.setState({ show_loader: true })

            var payment_gateway = ""
            var host = localStorage.getItem('host')
            var currency = this.state.dataObj.currency
            if (host == "visaero" && currency == "INR") {
                //Visaero Cashfree

                axios
                    .post('/visa-payment/getVisaeroCFPaymentToken', {
                        application_id: localStorage.getItem('application_id'),
                        "country": this.state.countryName,
                        "city": this.state.cityName,
                    },
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then((res) => {
                        // console.log(res)
                        // console.log(res.data.dataobj.applicationId)
                        let signatureData = "";
                        let signature;

                        //PROD 1613c19edf6a48dcd75a06fb71a8b7c3f1044cbf   TEST: 4ab8385ee7430a1932978337414168d7d5532baf
                        let secretKey = "4ab8385ee7430a1932978337414168d7d5532baf";
                        let returnUrl = this.state.server_url + "/visa-payment/visaero_cf_payment_webhook"
                        let notifyUrl = ""
                        //let notifyUrl = "https://wandaappserver.visaero.com/pcr-test/updatePaymentStatus" //backend api /pcr-test/updatePaymentStatus

                        let paymentDetailsObj = {
                            appId: res.data.dataobj.applicationId,
                            orderId: res.data.dataobj.orderId,
                            orderAmount: res.data.dataobj.orderAmount,
                            orderNote: 'Visa',
                            orderCurrency: res.data.dataobj.orderCurrency,
                            customerName: res.data.dataobj.customerName,
                            customerPhone: res.data.dataobj.customerPhone,
                            customerEmail: res.data.dataobj.customerEmail,
                            returnUrl: returnUrl,
                            notifyUrl: notifyUrl
                        }

                        var keys = Object.keys(paymentDetailsObj);
                        keys.sort();
                        keys.forEach((key) => {
                            signatureData += key + paymentDetailsObj[key];
                        });

                        signature = crypto.createHmac('sha256', secretKey).update(signatureData).digest('base64');
                        // console.log("signature : " + signature);
                        this.props.history.push("/payment-checkout", { 'paymentParam': paymentDetailsObj, 'signature': signature })

                        this.setState({ show_loader: false })

                    })
                    .catch((err) => {
                        console.log(err);
                    })



            }else if (host == "visadone" && currency == "INR") {
                //Visadone Cashfree
                //"/visa-payment/getVisadoneCFPaymentToken",
                //Visadone ICICI
                 
                axios
                  .post(
                    "/visa-payment/getEazyPayLink",
                    {
                      application_id: localStorage.getItem("application_id"),
                      country: this.state.countryName,
                      city: this.state.cityName,
                      host: localStorage.getItem("host"),
                    },
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    }
                  )
                  .then((res) => {
                    console.log(res)
                    this.setState({ show_loader: false });
                    console.log(">>>> res.payment_link "+res.data.payment_link)
                    window.location.replace(res.data.payment_link)

                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }else if (host == "visaero") {
                //in vis - stripe pg
                //in visaero pg
                // console.log('in stripe ..')


                const user_id = localStorage.getItem('user_id');
                const application_id = localStorage.getItem('application_id');
                // axios
                // .post('/visa-payment/getVisaeroStripePaymentToken', {
                //     "application_id": application_id,
                //     "user_id": user_id,
                //     "currency": currency
                // })
                // .then((resp) => {
                //     // console.log(resp)
                //     const stripe = await stripePromise;
                //     const result = stripe.redirectToCheckout({
                //         sessionId: resp.session_id,
                //     });
                //     if (result.error) {
                //         // If `redirectToCheckout` fails due to a browser or network
                //         // error, display the localized error message to your customer
                //         // using `result.error.message`.
                //     }
                //     // if(resp.data.data === "success") {
                //     //     //https://secure.3gdirectpay.com
                //     //     //https://secure1.sandbox.directpay.online
                //     //     var url = "https://secure1.sandbox.directpay.online/payv2.php?ID="+resp.data.transaction_token
                //     //     window.location.href = url
                //     // }else if(resp.data.data === "error") {
                //     //     alert("Something went wrong.. ")
                //     // } else {
                //     //     alert("Something went wrong.. ")
                //     // }
                // })




                localStorage.setItem('selected_payment_mode', "online");
                const stripe = await stripePromise;

                var data = {
                    "application_id": application_id,
                    "country": this.state.countryName,
                    "city": this.state.cityName,
                }

                // console.log(this.state.paymentSummeryObj.payment_summary.total)

                const response = await fetch(this.state.server_url + "/visa-payment/getVisaeroStripePaymentToken", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                const session = await response.json();

                // When the customer clicks on the button, redirect them to Checkout.
                const result = await stripe.redirectToCheckout({
                    sessionId: session.id,
                });

                this.setState({ show_loader: false })

                if (result.error) {
                    // If `redirectToCheckout` fails due to a browser or network
                    // error, display the localized error message to your customer
                    // using `result.error.message`.
                }

            }
            else if (host == "visadone") {
                //in sg - DPO pg
                const user_id = localStorage.getItem('user_id');
                const application_id = localStorage.getItem('application_id');
                axios
                    .post('/visa-payment/getVisadoneDPOPaymentToken', {
                        "application_id": application_id,
                        "user_id": user_id,
                        "currency": currency,
                        "country": this.state.countryName,
                        "city": this.state.cityName,
                    })
                    .then((resp) => {
                        // console.log(resp)
                        if (resp.data.data === "success") {
                            //https://secure.3gdirectpay.com
                            //https://secure1.sandbox.directpay.online
                            var url = resp.data.pay_link+"/payv2.php?ID=" + resp.data.transaction_token
                            window.location.href = url

                            this.setState({ show_loader: false })
                        } else if (resp.data.data === "error") {
                            alert("Something went wrong.. ")
                        } else {
                            alert("Something went wrong.. ")
                        }
                    })
            }
            else {
                alert("Something went wrong.. We are fixing it..")
                console.log("Payment Gateway not configured")
            }



        }







        return (
            <>
                {/* {console.log("Method", this.state.paymentMethod)} */}

                <h4><b>Payment Details</b></h4>



                <BasicInfoCard />
                <MDBCard style={{
                    marginTop: 20, marginBottom: 30
                }}>
                    <MDBCardBody>
                        <MDBCardTitle>
                            <MDBRow>
                                <MDBCol >Payment Breakup</MDBCol>
                                <MDBCol style={{ textAlign: 'right' }}>
                                    <Select
                                        style={{ width: '13%', textAlign: 'left' }}
                                        name="selected_currency"
                                        onChange={this.handleOptionChange}
                                        value={this.state.selected_currency}
                                    >
                                        {
                                            this.state.supported_currency.map((flag) =>
                                                <MenuItem value={flag} key={flag}>
                                                    {/* <img src={flag.flag} style={{height: '1rem', width: '1.2rem'}} id={styles.flagThumbnail} /> */}
                                                    {flag}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardTitle>
                        <hr />
                        <MDBCardText>
                            <MDBRow>
                                <MDBCol size="4">
                                    <MDBTable borderless>
                                        <tr>
                                            <th style={{ color: 'grey' }}>Visa Embassy Fee</th>
                                            <td style={{ textAlign: 'right' }}>{this.state.dataObj.currency} {this.state.dataObj.visa_embassy_fees}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey' }}>Service Fee</th>
                                            <td style={{ textAlign: 'right' }}>{this.state.dataObj.currency} {this.state.dataObj.service_fees}</td>
                                        </tr>
                                        {this.state.success ?
                                            <tr>
                                                <th style={{ color: "grey" }}>Applied Coupon(-)</th>
                                                <td style={{ color: "green", textAlign: 'right' }}><b> -{this.state.dataObj.currency} {this.state.discount_value}  </b></td>
                                            </tr> : ""
                                        }
                                        {this.state.additionalTax.map((tax) => (

                                            <tr>
                                                <th style={{ color: 'grey' }}>{tax.additional_tax_type} ({tax.additional_tax_percentage} %)</th>
                                                <td style={{ textAlign: 'right' }}>{this.state.dataObj.currency} {tax.additional_tax_value}</td>
                                            </tr>
                                        ))}
                                        {/* { this.state.isCouponApplied &&
                                        <tr>
                                        <th style={{color:'grey'}}>Applied Coupon(-)</th>
                                        <td style={{color:'#109046'}}>-INR 849</td>
                                        </tr>
                                    } */}
                                        <tr>
                                            <th style={{ color: 'grey' }}>Total</th>
                                            <td style={{ textAlign: 'right' }}>{this.state.dataObj.currency} {this.state.dataObj.total_payment}</td>
                                            {/* { !this.state.isCouponApplied &&
                                            <td>INR 12,849</td>
                                        }
                                        {this.state.isCouponApplied &&
                                            <td>INR 12,000</td>
                                        } */}
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardText>
                    </MDBCardBody>
                </MDBCard>
                <MDBCard style={{
                    marginBottom: 20
                }}>
                    <MDBCardBody>
                        {this.state.success ?
                            <>
                                <h6>Applied Promo Code</h6>

                                <div style={{ backgroundColor: "white", border: "5px solid lightgrey", width: "80%", }}>
                                    <MDBRow>
                                        <MDBCol lg="1">
                                            <img src={this.state.banner_image} style={{ width: "100px", height: "80px", objectFit: "contain", margin: "2px" }} ></img>
                                        </MDBCol>
                                        <MDBCol lg="5">
                                            <div style={{ overflow: "hidden", marginLeft: "50px" }}>
                                                <h3> {this.state.promocode_subtitle} </h3>
                                                <p style={{ marginTop: "", overflowY: "visible" }}>{this.state.banner_message}</p>
                                            </div>
                                        </MDBCol>
                                        <MDBCol lg="4"></MDBCol>
                                        <MDBCol lg="2" style={{ marginTop: "2%" }}>
                                            <a style={{ color: this.state.brand_color, marginLeft: "0%", fontWeight: "bolder" }} onClick={this.deleteToggle} >Remove</a>
                                        </MDBCol>
                                    </MDBRow>
                                </div>
                                {/* <div style={{display : "flex " , alignItems : "center" }}>
                                

                            <h4 style={{textDecoration : "underline"}}><b>{this.state.promocode_title}</b></h4>
                            </div> */}
                            </>
                            :

                            <div onClick={this.missingFieldToggle} style={{ display: "flex", justifyContent: "start", alignItems: "center", cursor: "pointer" }} >
                                <MDBIcon icon="ticket-alt" style={{ color: this.state.brand_color, marginBottom: "5px", marginRight: "10px" }} />
                                <h4 style={{ textDecoration: "underline" }}>Have a Coupon Code.</h4>


                            </div>


                        }
                    </MDBCardBody>
                </MDBCard>


                <MDBCard style={{ marginTop: 20, marginBottom: this.state.showPaymentMethod ? 0 : 100 }}>
                    <MDBCardBody>
                        <MDBCardTitle>
                            <MDBRow>
                                <MDBCol>
                                    Processing Center
                                </MDBCol>
                            </MDBRow>
                        </MDBCardTitle>
                        <hr />
                        <MDBRow>
                            <MDBCol lg="6">
                                <InputLabel id="select-city">Select Country</InputLabel>
                                <Select
                                    labelId="select-city"
                                    style={{ width: '50%', textAlign: 'left' }}
                                    name="processing_center"
                                    onChange={this.handleCountryChange}
                                    value={this.state.countryName}
                                >
                                    {this.state.countryList.map((country) =>
                                        <MenuItem value={country.country_name} key={country.country_name}>{country.country_name}</MenuItem>
                                    )}
                                </Select>
                            </MDBCol>
                            <MDBCol lg="6">
                                <InputLabel id="select-city">Select City</InputLabel>
                                <Select
                                    labelId="select-city"
                                    style={{ width: '50%', textAlign: 'left' }}
                                    name="processing_center"
                                    onChange={this.handleCityChange}
                                    value={this.state.cityName}
                                >
                                    {this.state.cityList.map((country) =>
                                        <MenuItem value={country} key={country}>{country}</MenuItem>
                                    )}


                                    {/* )
                            } */}
                                </Select>
                            </MDBCol>
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>

                {this.state.showPaymentMethod &&
                    <MDBCard style={{ marginTop: 20, marginBottom: 100 }}>
                        <MDBCardBody>
                            <MDBCardTitle>
                                <MDBRow>
                                    <MDBCol>
                                        Payment Method
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardTitle>
                            <hr />
                            <MDBRow>
                                {this.state.paymentMethod.map((payment, index) => (


                                    <>
                                        {payment.payment_mode === "online" &&
                                            <MDBCol>
                                                <input defaultChecked={index == 0} type="radio" id="payment_mode" name="payment_mode" value="online" onChange={this.handlePaymentMethod} /> Pay Online
                                </MDBCol>
                                        }
                                        {payment.payment_mode === "bank_transfer" &&
                                            <MDBCol>
                                                <input defaultChecked={index == 0} type="radio" id="payment_mode" name="payment_mode" value="bank_transfer" onChange={this.handlePaymentMethod} /> Bank Transfer
                                </MDBCol>
                                        }
                                        {payment.payment_mode === "pay_at_center" &&
                                            <MDBCol>
                                                <input defaultChecked={index == 0} type="radio" id="payment_mode" name="payment_mode" value="pay_at_center" onChange={this.handlePaymentMethod} /> Pay at Center
                                </MDBCol>
                                        }


                                    </>
                                ))}
                            </MDBRow>

                            {/* {this.state.paymentMode === "online" &&

// <MDBRow>
//     <MDBCol style={{ marginTop: "10px" }}>
//         <h6 style={{ color: "red", fontWeight: "bolder", display: "inline" }}>Note :</h6> <span>If you choose  NEFT option to pay it will take  3-4 business working days to credit in your account.</span>
//     </MDBCol>
// </MDBRow>









} */}








                            {this.state.paymentMode === "bank_transfer" &&
                                <>

                                    <MDBRow style={{ margin: "10px 0" }}>
                                        <MDBCol lg="1">
                                            <h6 style={{ color: "red", fontWeight: "bold" }}>Note :</h6>
                                        </MDBCol>
                                        <MDBCol lg="11">
                                            <span>If you choose to pay through bank transfer, you must add the transaction number generated after the money is transferred. You can enter the transaction number against this visa application by visiting the track application screen.
                                           The application would be submitted for processing only after the transaction number has been submitted.</span>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        {this.state.paymentMethod.map((payment) => {
                                            if (payment.payment_mode === "bank_transfer") {
                                                return (
                                                    <>


                                                        {payment.payment_config.map(
                                                            // this.handlePaymentCard)}


                                                            (pay) => (


                                                                <MDBCol lg="4">

                                                                    <MDBCard>
                                                                        <MDBCardBody>

                                                                            <MDBRow>
                                                                                <MDBCol >
                                                                                    {pay.bank_details.split("\\l").map((info1) => {
                                                                                        return (
                                                                                            <p className="mb-0">{info1}</p>
                                                                                        )
                                                                                    })}
                                                                                </MDBCol>
                                                                            </MDBRow>
                                                                        </MDBCardBody>
                                                                    </MDBCard>
                                                                </MDBCol>
                                                            ))}
                                                    {/* ))} 
                                                            ))}
                                                    ))} 
                                                            ))}
                                                    ))} 
                                                            ))} */}
                                                    </>
                                                )
                                            }
                                        })}
                                    </MDBRow>
                                </>
                            }

                            {
                                this.state.paymentMode === "pay_at_center" &&
                                <>
                                    <MDBRow style={{ margin: "10px 0" }}>
                                        <MDBCol lg="1">
                                            <h6 style={{ color: "red", fontWeight: "bold" }}>Note :</h6>
                                        </MDBCol>
                                        <MDBCol lg="11">
                                            <span>You must make the payment within next 48 hours at our payment center.</span>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol>

                                            <h5 style={{ fontWeight: "bolder" }}>Payment Centers</h5>

                                        </MDBCol>
                                    </MDBRow>


                                    <MDBRow>
                                        {this.state.paymentMethod.map((payment) => {
                                            if (payment.payment_mode === "pay_at_center") {
                                                return (
                                                    <>
                                                        {payment.payment_config.map((pay) => (


                                                            <MDBCol lg="3">

                                                                <MDBCard>
                                                                    <MDBCardBody>

                                                                        <MDBRow>
                                                                            <MDBCol>
                                                                                {pay.center_details.split("\\l").map((info1) => {
                                                                                    return (
                                                                                        <p className="mb-0">{info1}</p>
                                                                                    )
                                                                                })}
                                                                            </MDBCol>
                                                                        </MDBRow>
                                                                    </MDBCardBody>
                                                                </MDBCard>
                                                            </MDBCol>

                                                        ))}
                                                    </>)
                                            }
                                        })}



                                    </MDBRow>
                                </>
                            }

                        </MDBCardBody>

                    </MDBCard>

                }




                <MDBModal centered isOpen={this.state.showMissingFieldModal} toggle={this.missingFieldToggle}>
                    <MDBModalHeader toggle={this.missingFieldToggle}>Apply Code</MDBModalHeader>
                    <MDBModalBody>
                        <>

                            <MDBRow className="d-flex align-items-center">
                                <MDBCol lg="8">

                                    <MDBInput

                                        name="coupon_code"
                                        label="Coupon Code"
                                        group type="text"
                                        value={(this.state.coupon_code).toUpperCase()}
                                        onChange={(e) => this.setState({ coupon_code: (e.target.value) })}
                                    />
                                </MDBCol>
                                <MDBCol lg="4">
                                    {!this.state.applyCouponCode &&
                                        <MDBBtn id="reviewBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, marginTop: "", fontSize: 'calc(8px + .5rem)', textTransform: 'none' }}
                                            color="none" onClick={this.handleCouponCode}>Verify Now</MDBBtn>
                                    }
                                </MDBCol>
                            </MDBRow>

                            {this.state.promocode_challenge === "bin" &&
                                <MDBRow>
                                    <MDBCol  >

                                        {/* <MDBInput 
                                            name="credit_card"
                                            label="Enter credit card first 6 digit" 
                                            group type="text"
                                            value={this.state.creditCard}
                                            onChange={(e)=> this.setState({creditCard : e.target.value})}
                                            > */}
                                        <h6 style={{ color: "grey" }}>Enter credit card first 6 digit</h6>
                                        <div style={{ display: "flex", marginBottom: "5px" }}>

                                            {/* <TextField type="number" style={{ width: "30px", marginLeft: "2px", height: "50px", border: "none", marginTop: "10px" }}
                                                inputRef={(input) => { this.textInput1 = input; }}
                                                value={this.state.number1} onChange={this.handleCreditCard1} inputProps={{ maxLength: 1, }} />


                                            <TextField type="number" style={{ width: "30px", marginLeft: "2px", height: "50px", border: "none", marginTop: "10px" }}
                                                inputRef={(input) => { this.textInput2 = input; }}
                                                value={this.state.number2} onChange={this.handleCreditCard2} inputProps={{ maxLength: 1, }} />

                                            <TextField type="number" style={{ width: "30px", marginLeft: "2px", height: "50px", border: "none", marginTop: "10px" }}
                                                inputRef={(input) => { this.textInput3 = input; }}
                                                value={this.state.number3} onChange={this.handleCreditCard3} inputProps={{ maxLength: 1, }} />

                                            <TextField type="number" style={{ width: "30px", marginLeft: "2px", height: "50px", border: "none", marginTop: "10px" }}
                                                inputRef={(input) => { this.textInput4 = input; }}
                                                value={this.state.number4} onChange={this.handleCreditCard4} inputProps={{ maxLength: 1, }} />

                                            <TextField type="number" style={{ width: "30px", marginLeft: "2px", height: "50px", border: "none", marginTop: "10px" }}
                                                inputRef={(input) => { this.textInput5 = input; }}
                                                value={this.state.number5} onChange={this.handleCreditCard5} inputProps={{ maxLength: 1, }} />

                                            <TextField type="number" style={{ width: "30px", marginLeft: "2px", height: "50px", border: "none", marginTop: "10px" }}
                                                inputRef={(input) => { this.textInput6 = input; }}
                                                value={this.state.number6} onChange={this.handleCreditCard6} inputProps={{ maxLength: 1, }} /> */}
                                            <OtpInput
                                                value={this.state.number1}
                                                onChange={this.handleCreditCard1}
                                                numInputs={6}
                                                containerStyle={{ paddingLeft: "5px", marginTop: "5px" }}
                                                inputStyle={{ border: "none", borderBottom: "1px solid black", marginRight: "5px", width: "30px" }}
                                                isInputNum={true}
                                                focusStyle={{ outlineWidth: "0px" }}
                                            />


                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px", marginLeft: "8px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px", marginLeft: "8px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px", marginLeft: "8px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                            <span style={{ color: "grey", marginTop: "5px", fontSize: "25px" }}>X</span>
                                        </div>


                                        {/* </MDBInput> */}
                                    </MDBCol>
                                </MDBRow>
                            }

                            {this.state.promocode_challenge === "domain" &&

                                <MDBRow>
                                    <MDBCol  >
                                        <MDBInput

                                            name="company_email"
                                            label="Enter company email id"
                                            group type="email"
                                            value={this.state.email_id}
                                            onChange={this.handleEmailChange}
                                        />
                                    </MDBCol>
                                </MDBRow>

                            }
                            {this.state.applyCouponCode &&
                                <div style={{ backgroundColor: "lightgray", width: "100%", height: "100px" }}>

                                    <MDBRow>

                                        <MDBCol lg="2">
                                            {/* <img src="https://s3.amazonaws.com/visaero.qa.applicant.profile/SAHIL%20PIC.jpg" /> */}
                                            <img src={this.state.banner_image} style={{ width: "100px", height: "90px", objectFit: "contain", marginLeft: "2px", marginTop: "3px" }} ></img>
                                        </MDBCol>
                                        <MDBCol lg="10">
                                            <div style={{ overflow: "hidden", marginLeft: "50px", height: "100px" }}>
                                                <h3> {this.state.promocode_subtitle} </h3>
                                                <p style={{ marginTop: "-10px", height: "20px", overflowY: "visible" }}>{this.state.banner_message}</p>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </div>
                            }
                        </>
                        {this.state.alertMsg &&
                            <MDBAlert color='danger' className="mt-2 mb-0"> {this.state.errormsg} </MDBAlert>
                        }



                    </MDBModalBody>

                    {this.state.applyCouponCode &&
                        <MDBModalFooter>
                            <MDBBtn color="dark" style={{ textTransform: 'none', color: 'white', backgroundColor: this.state.brand_color }} onClick={this.applyCode}>Apply Coupon</MDBBtn>
                        </MDBModalFooter>
                    }
                </MDBModal>
                {/* <MDBCard className="mt-4">
                    <MDBCardBody>
                    <MDBCardTitle>Processing Center</MDBCardTitle>
                    <hr/>    
                    <MDBCardText>
                    <MDBRow>
                    <MDBCol size='12' sm='6' md='6' lg='3'>
                    <small>City</small>
                    <Select 
                    id="city"
                    style={{ width:'100%',textAlign:'left', padding:0}}  
                    name="city"
                    >
                    <MenuItem value="Pune">Pune</MenuItem>
                    </Select>
                    </MDBCol>
                    </MDBRow>
                    </MDBCardText>
                    </MDBCardBody>
                </MDBCard> */}
                {/* <div className="mt-4">
                    <MDBCard>
                    <MDBLink to="#" link data-toggle="modal" data-target="#couponCodeModal">Have a Coupon Code?</MDBLink>
                    </MDBCard>
                    <div className="modal fade" id="couponCodeModal" tabindex="-1" role="dialog" aria-labelledby="couponCodeModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggle()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                    
                    <h4 className="modal-title" id="couponCodeModalLabel"><b>Apply Coupon</b></h4>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                    <MDBRow >
                    <MDBCol size="8">
                    <MDBInput type="text" label="Enter Coupon Code" />
                    </MDBCol>
                    <MDBCol size="4" className="text-center mt-3">
                    { !this.state.isCouponApplied &&
                        <MDBBtn color="none" onClick={()=>this.setState({isCouponApplied:true})} style={{color:'white',backgroundColor:'#673784', textTransform:'none', borderRadius:'40px'}}>Apply</MDBBtn>
                    }
                    </MDBCol>
                    
                    <MDBCard className={styles.couponCard1} >
                    <img src={discount_icon}  />
                    </MDBCard>
                    <MDBCard className={styles.couponCard2} >
                    Axis Bank
                    </MDBCard>
                    <MDBCard style={{minHeight:'5rem', width:'10rem',borderRadius:0, border:'none',}}>
                    ............................................
                    </MDBCard>
                    
                    </MDBRow>
                    </div>
                    <div className="modal-footer">
                    { this.state.isCouponApplied &&
                        <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'#673784', textTransform:'none', borderRadius:'40px'}}>Apply Coupon</MDBBtn>
                    }
                    </div>
                    </div>
                    </div>
                    </div>
                </div>  */}

                {/* <MDBCard className="mt-4" style={{marginBottom:"10rem"}}>
                    <MDBCardBody>
                    <MDBCardTitle>Payment Mode</MDBCardTitle>
                    <hr/>    
                    <MDBCardText>
                    <MDBRow>
                    <MDBCol size="6" lg="2">
                    <input type="radio" id="pay_mode" name="pay_mode" value="Pay from Credit"  defaultChecked/> Pay from Credit
                    </MDBCol>
                    <MDBCol size="6" lg="2">
                    <input type="radio" id="pay_mode" name="pay_mode" value="Pay Online"  /> Pay Online
                    </MDBCol>
                    </MDBRow>
                    </MDBCardText>
                    </MDBCardBody>
                </MDBCard> */}
                {this.state.paymentMode === "online" ?
                    <MDBRow>
                        <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" }} color="white" className="pb-1 pt-1 text-right">

                            <MDBRow>
                                <MDBCol size="12" xs="6" sm="6" md="8" lg="8" style={{ textAlign: "center" }}>
                                    {
                                        this.state.isOnlineError &&
                                        <MDBAlert color='danger'>{this.state.errorTextMsg}</MDBAlert>
                                    }
                                </MDBCol>
                                <MDBCol size="12" sm="6" md="4" lg="4">
                                    <MDBBtn id="reviewBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, width: '40%', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={handlePayNow}>Pay Now</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBFooter>
                    </MDBRow> :

                    <MDBRow>
                        <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", zIndex: "1", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" }} color="white" className="pb-1 pt-1 text-right">

                            <MDBRow >
                                <MDBCol size="12" xs="6" sm="6" md="8" lg="8" style={{ textAlign: "center" }}>
                                    {
                                        this.state.isOfflineError &&
                                        <MDBAlert color='danger'>{this.state.errorTextMsg}</MDBAlert>
                                    }
                                </MDBCol>
                                <MDBCol size="12" sm="6" md="4" lg="4">
                                    <MDBBtn id="reviewBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, width: '40%', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handlePaymentProceed}>Proceed</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBFooter>
                    </MDBRow>
                }

                <MDBModal centered isOpen={this.state.showDeleteModall} toggle={this.deleteToggle}>
                    <MDBModalHeader toggle={this.deleteToggle}>Delete Coupon</MDBModalHeader>
                    <MDBModalBody>
                        Are you sure, you want to remove Coupon Code?
                  </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.deleteToggle} >Cancel</MDBBtn>
                        <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.removeCoupon}>Remove</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>


                {
                    this.state.show_loader &&

                    <img src={paymentLoader} className={styles.payment_loader} />

                }

            </>


        )
    }
}

export default PaymentDetails;
